import { useState } from 'react'
import { Button, ObModal } from '@outbound-ai/ursa'
import styled from 'styled-components'

interface IProps {
  show: boolean
  callPayer: (value: boolean) => void
}

export const PayerCallRequestConfirmationModal = ({ callPayer, show }: IProps) => {
  const [showModal, setShowModal] = useState(show)

  return (
    <Div>
      <ObModal
        show={showModal}
        size="lg"
        customSize="small"
        close={() => {
          callPayer(false)
          setShowModal(false)
        }}
        title={'Payer Unavailable'}
        modalFooter={
          <ModalFooter>
            <Button
              variant="primary"
              size="normal"
              radius="rounded"
              width="100%"
              onClick={() => {
                callPayer(true)
              }}
            >
              Yes, Proceed
            </Button>
            <Button
              variant="primary-outline"
              size="normal"
              radius="rounded"
              width="100%"
              contentType="text-icon"
              onClick={() => {
                callPayer(false)
                setShowModal(false)
              }}
            >
              No, Cancel
            </Button>
          </ModalFooter>
        }
      >
        According to our records this payer is currently closed. Would you like to proceed with this call?
      </ObModal>
    </Div>
  )
}

const Div = styled.div``

const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  width: -webkit-fill-available;
`
